import React from 'react';
import {
  gtmEventIdentifiers,
  helpResourceLink,
  privacyPolicyLink,
  routePaths,
} from '../../../utils/consts';
import { useTranslation } from 'react-i18next';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import analyticsEventFirer from '../../../utils/functions/analyticsEventFirer';
import { startTour } from '../../../actions/tour';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { setContactModalOn } from '../../../actions/modal';
import { logout } from '../../../actions/auth';
import { TokenizedLink } from '../../shared_components/Header';
import { AQ101, UserInfo } from '../../../utils/interface';

interface Props {
  userInfo: UserInfo;
  isMobileNavOpened: boolean;
  setIsMobileNavOpened: Function;
  logout: Function;
  showTourMenu: boolean;
  setVersionHistoryOpen: Function;
  setTutorialOpen: Function;
  startTour: Function;
  setContactModalOn: Function;
  aq101: AQ101;
  setAQ101On: Function;
  setAQ101Off: Function;
}

const MobileNavigationMenu = ({
  userInfo,
  isMobileNavOpened,
  setIsMobileNavOpened,
  logout,
  showTourMenu,
  startTour,
  aq101,
  setAQ101On,
  setAQ101Off,
}: Props) => {
  const [history, location] = [useHistory(), useLocation()];
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  const handleCloseMobileNavMenu = () => {
    setIsMobileNavOpened(false);
  };

  return (
    <div
      className={`only-mobile-navigation ${
        isMobileNavOpened ? 'opened' : 'closed'
      }`}
    >
      {!userInfo.isPublic && (
        <nav>
          <li>
            <NavLink
              to={routePaths.app}
              activeClassName="active"
              exact
              onClick={handleCloseMobileNavMenu}
            >
              {translate('LocationHeader')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to={routePaths.dataAnalytics}
              activeClassName="active"
              onClick={handleCloseMobileNavMenu}
            >
              {translate('DataAnalyticsHeader')}
            </NavLink>
          </li>
          <li>
            <TokenizedLink callbackUrl="/alerts">
              {translate('AlertsHeader')}
            </TokenizedLink>
          </li>
          <li>
            <TokenizedLink callbackUrl="/device-manager">
              {translate('FleetManagementHeader')}
            </TokenizedLink>
          </li>
          <li>
            <a
              onClick={() => {
                const helpkitButton = document.getElementById(
                  'helpkit-launcherButton--earthsense',
                );
                if (helpkitButton) {
                  helpkitButton.click();
                }
              }}
            >
              {translate('HelpHeader')}
            </a>
          </li>
          <li>
            <a
              href={helpResourceLink.url}
              target={helpResourceLink.target}
              className="tourResources"
              onClick={() =>
                // Analytics
                analyticsEventFirer(gtmEventIdentifiers.resourcesLink)
              }
            >
              {translate('ResourcesLinkTitle')}
            </a>
          </li>
          {showTourMenu ? (
            <li>
              <a
                onClick={() => {
                  if (location.pathname.includes('analysis')) {
                    dispatch({ type: 'analysis_tour_toggle' });
                    return;
                  }
                  if (location.pathname.includes('alerts')) {
                    dispatch({ type: 'alerts_tour_toggle' });
                    return;
                  }
                  // Analytics
                  analyticsEventFirer(gtmEventIdentifiers.tour);
                  handleCloseMobileNavMenu();
                  startTour();
                }}
              >
                {translate('TourLinkTitle')}
              </a>
            </li>
          ) : null}
          <li>
            <a
              href="#"
              target={privacyPolicyLink.target}
              className="tourResources"
              onClick={() =>
                // Analytics
                analyticsEventFirer(gtmEventIdentifiers.privacyPolicyLink)
              }
            >
              {translate('PrivacyLinkTitle')}
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                if (localStorage.getItem('Versions'))
                  localStorage.removeItem('Versions');
                if (localStorage.getItem('alerts'))
                  localStorage.removeItem('alerts');
                if (sessionStorage.getItem('locationRefreshed'))
                  sessionStorage.removeItem('locationRefreshed');
                history.push(routePaths.app);
                logout();
              }}
            >
              {translate('LogoutLinkTitle')}
            </a>
          </li>
        </nav>
      )}
      {userInfo.isPublic && (
        <ul>
          {userInfo.today ? (
            <>
              <li className="only-mobile">
                <NavLink
                  to={routePaths.today}
                  activeClassName="active mobile-active"
                  onClick={handleCloseMobileNavMenu}
                  exact
                >
                  {translate('TodayTitle')}
                </NavLink>
              </li>
            </>
          ) : (
            <></>
          )}
          <li className="only-mobile">
            <NavLink
              to={routePaths.app}
              activeClassName="active mobile-active"
              onClick={handleCloseMobileNavMenu}
              exact
            >
              {translate('LocationHeaderPublic')}
            </NavLink>
          </li>
          <li className="only-mobile">
            <NavLink
              to={routePaths.dataAnalytics}
              activeClassName="active"
              onClick={handleCloseMobileNavMenu}
            >
              {translate('DataAnalyticsHeader')}
            </NavLink>
          </li>
          <li>
            <a
              onClick={() => {
                if (aq101.on) {
                  setAQ101Off();
                } else {
                  setAQ101On();
                }
              }}
            >
              {translate('AirQuality101Title')}
            </a>
          </li>
          <li>
            <a href={userInfo.projectLink} target="_blank">
              {translate('CouncilProjectTitle')}
            </a>
          </li>
        </ul>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      startTour,
      setContactModalOn,
      logout,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(MobileNavigationMenu);
